
import './CoreServices.scss';
import { Container, Row, Col } from 'react-bootstrap';
import { MobileDevIcon } from '../assets/icons/mobile-dev-icon';
import { DesignIcon } from '../assets/icons/design-icon';
import { WebDevIcon } from '../assets/icons/web-dev-icon';
import { BrandIcon } from '../assets/icons/branding-icon';
import { AiIcon } from '../assets/icons/ai-icon';
import { CyberSecurityIcon } from '../assets/icons/cybersecurity-icon';
import { DataIcon } from '../assets/icons/data-icon';
import { NextPageIcon } from '../assets/icons/next-page-icon';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.12, ease: "easeOut" }
  })
};

const CoreServices = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(["translation", "de"])

  const services = [
    { icon: <AiIcon />, titleKey: 'coreServices.service6.title', descKey: 'coreServices.service6.description', highlight: true },
    { icon: <DesignIcon />, titleKey: 'coreServices.service1.title', descKey: 'coreServices.service1.description', highlight: false },
    { icon: <CyberSecurityIcon />, titleKey: 'coreServices.service7.title', descKey: 'coreServices.service7.description', highlight: true },
    { icon: <WebDevIcon />, titleKey: 'coreServices.service3.title', descKey: 'coreServices.service3.description', highlight: false },
    { icon: <MobileDevIcon />, titleKey: 'coreServices.service2.title', descKey: 'coreServices.service2.description', highlight: false },
    { icon: <DataIcon />, titleKey: 'coreServices.service5.title', descKey: 'coreServices.service5.description', highlight: true },
    { icon: <BrandIcon />, titleKey: 'coreServices.service4.title', descKey: 'coreServices.service4.description', highlight: false },
  ];

  return (
    <div className="core-content" >
      <Container fluid>
        <motion.h1
          className='core-title'
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {t('coreServices.title')}
        </motion.h1>
        <motion.p
          className='core-subtitle'
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          {t('coreServices.subtitle')}
        </motion.p>
        <div className="core-content__services">
          {services.map((service, index) => (
            <motion.div
              key={index}
              custom={index}
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className={`core-content__services__card ${service.highlight ? 'core-content__services__card--highlight' : ''}`}
            >
              <div className="core-content__services__card__icon">
                {service.icon}
              </div>
              <div className="core-content__services__card__title">
                <h3>{t(service.titleKey)}</h3>
              </div>
              <div className="core-content__services__card__description">
                <p>{t(service.descKey)}</p>
              </div>
            </motion.div>
          ))}
        </div>
        <Row>
          <Col className='more-page' onClick={() => navigate('services')}>
            <span className='more-page-text'>{t('coreServices.more_services.text')}</span>
            <div className='next-icon'>
              <NextPageIcon />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default CoreServices
